import axios from '@/lib/axios'
import { buildAdminRequestConfig, type OrganizationId } from '@/lib/organization-scoping'
import type { QueryFunctionContext } from '@tanstack/react-query'
import type {
  NotificationEvent,
  NotificationEventAudience,
  SyncNotificationEventRecipientsInput,
} from './notification-events.types'

export interface NotificationEventOrganizationScope {
  organizationId: OrganizationId
}

/** The API lists organization events when no audience is given. */
export type NotificationEventIndexQueryKeyEntries = NotificationEventOrganizationScope & {
  audience?: NotificationEventAudience | undefined
}

/** Query functions read only the key. */
type NotificationEventQueryContext<TKey> = Pick<QueryFunctionContext<[TKey]>, 'queryKey'>

export async function getNotificationEvents({
  queryKey: [{ organizationId, audience }],
}: NotificationEventQueryContext<NotificationEventIndexQueryKeyEntries>) {
  return (
    (await axios.get<NotificationEvent[]>(
      '/notification-events',
      buildAdminRequestConfig({
        organizationId,
        params: audience ? { audience } : undefined,
      })
    )) || []
  )
}

// Resolves to the updated event: the API sends resources unwrapped (`JsonResource::withoutWrapping()`).
export async function syncNotificationEventRecipients({
  organizationId,
  eventId,
  recipientIds,
}: SyncNotificationEventRecipientsInput & NotificationEventOrganizationScope) {
  return axios.put<NotificationEvent>(
    `/notification-events/${eventId}/recipients`,
    {
      recipient_ids: recipientIds,
    },
    buildAdminRequestConfig({ organizationId })
  )
}
